module.exports = __webpack_public_path__ + "imgs/phototravel.8a4f78b8.webp";